import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class TestResults210626 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 21/06/2026 Results(Sattahip)</h3>
      <br />
      <br />


        <div><Link to='/conduct-ratchadapornn'>1. AAT 7822  MS.RATCHADAPORN NONNUSAT(PASS with Distinction)---Accquired Rank 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-napolp'>2. ATT  7910  MR.NAPOL PITAYAPAT(PASS with Distinction)---Accquired Rank 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-asdawutc'>3. ATT  7925  LT.ASDAWUT CHODSAPTHAWEE(PASS)---Accquired Rank 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-nirunc'>4. AAT 7783  LT.NIRUN CHANTAWARO(PASS)---Accquired Rank 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-sunyal'>5. AAT 7972  CPO1.SUNYA LAEID(PASS)---Accquired Rank 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-angieo'>6. ATT 7884  MS.ANGELICA JOSELINE OLSSON(PASS)--Accquired Rank 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-barbarab'>7. AAT 8027  MS.BARBARA BARZARKINA(PASS with Distinction)---Accquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-panyasuphak'>8. AAT 8029  MS.PANYASUPHA KHEMARUT(PASS with Distinction)---Accquired Rank 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-zaidena'>9. AAT 8044  MR.ZAIDEN ANDERSSON(PASS)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-benjaminb'>10. AAT 8045  MR.BENJAMIN BROWN(PASS)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-tylerb'>11. AAT 8046  MR.TYLER BROWN(PASS)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-wyonab'>12. AAT 8047  MS. WYONA BROWN(PASS)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-kansinees'>13. AAT 8048  MS.KANSINEE SAIMONTREE(PASS)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-narns'>14. AAT 8049  MR.NARN SUDRAK(PASS)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-naruekarink'>15. AAT 8036  MR.NARUEKARIN KHEMARUT(PASS)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-jaiklal'>16. AAT 8067  MR.JAIKLA LORGUNPAI(PASS)---Accquired Rank 10KYU</Link></div>
        <br />


        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default TestResults210626;
